import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private status = signal<boolean>(false);

  public readonly status$ = this.status.asReadonly();

  updateLoaderState() {
    this.status.update(value => !value);
  }

  setLoaderState(value: boolean) {
    this.status.set(value);
  }
}
